// extracted by mini-css-extract-plugin
module.exports = {"legend":"a10a3f92e9--legend--3ztba","chart":"a10a3f92e9--chart--3mSBG"};